import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { createRoutes, match } from 'react-router'

export function getSentryTransactionForActions(actionType, actionPayload) {
  if (window.brumbrum.sentry_trace_id) {
    const sentryHub = Sentry.getCurrentHub()
    return sentryHub.startTransaction({
      traceId: window.brumbrum.sentry_trace_id,
      op: 'ajax',
      name: actionType,
      data: {
        actionType,
        actionPayload,
      },
      description: `${actionPayload.method} ${actionPayload.uri}`,
    })
  }
  return {
    traceId: 'trace-id-fallback',
    spanId: 'span-id-fallback',
    setHttpStatus: () => null,
    setTag: () => null,
    finish: () => null,
  }
}

export const initSentry = routes => {
  const { sentry_dsn: dsn, environment_name: environment } =
    window.brumbrum || {}

  if (!dsn || !routes) {
    return
  }

  Sentry.init({
    dsn,
    environment,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: [/brumbrum\.it/],
        routingInstrumentation: Sentry.reactRouterV3Instrumentation(
          history,
          createRoutes(routes),
          match
        ),
        shouldCreateSpanForRequest: url =>
          !/^https:\/\/gtm\.brumbrum\.it/.test(url),
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.01,
  })

  // https://docs.sentry.io/product/sentry-basics/tracing/distributed-tracing/#traces
  // Traces are not an entity in and of themselves. Rather, a trace is defined
  // as the collection of all transactions that share a trace_id value.
  window.brumbrum.sentry_trace_id = Sentry.getCurrentHub()
    .getScope()
    .getTransaction().traceId
}
